export const formatarData = (dataString) => {
    if (!dataString) return '--';
    try {
        const data = new Date(dataString);
        return data.toLocaleDateString('pt-BR');
    } catch (error) {
        return '--';
    }
};

export const formatarDataHora = (dataString) => {
    if (!dataString) return '--';
    try {
        const data = new Date(dataString);
        return `${data.toLocaleDateString('pt-BR')} - ${data.toLocaleTimeString('pt-BR', {
            hour: '2-digit',
            minute: '2-digit',
        })}`;
    } catch (error) {
        return '--';
    }
};

export const isRevisaoPendente = (proximaRevisao, diasAviso = 60) => {
    if (!proximaRevisao) return false;
    try {
        const proximaData = new Date(proximaRevisao);
        const hoje = new Date();
        const diffDias = (proximaData - hoje) / (1000 * 60 * 60 * 24);
        return diffDias <= diasAviso;
    } catch (error) {
        return false;
    }
};
